<div *ngIf="isMobile">
  <div class="mobile-header-bar" style="background-color: #000000;">
    <div class="left" (click)="gotoPrevius()">
      <img src="assets/icon/m-back.svg" alt="back">
    </div>
    <div class="title">
      <p> {{ item.name | textLimit: 25}}</p>
    </div>
    <div>
      <span *ngIf="verifyLogin && isPhone">
        <img src="assets/icon/dil.svg" class="dil" alt="fav-icon" *ngIf="!item['isFavourite']" (click)="addToFav(item)">
        <img src="assets/icon/fav.svg" alt="heart fill" class="icon"
          *ngIf="item['isFavourite'] && item['isFavourite']" (click)="addToFav(item)">
      </span>
    </div>
  </div>
</div>
<div class="product-world"
  [ngClass]="{three: noOfpannel == 'three',one: noOfpannel == 'one',zero: noOfpannel == 'zero',two: noOfpannel == 'two'}">
  <div class="col-12">
    <swiper [config]="config" [navigation]="{}" [pagination]="{ clickable: true }" [pagination]="{
                type: 'progressbar'
              }" class="mySwiper custom-swiper">
      <ng-template swiperSlide>
        <div class="card bg-dark content2 text-white"
          [ngClass]="{'mob-ht-1': one-pannel,'mob-ht-2': two-pannel,'mob-ht-3': three-pannel}">
          <div class="content-overlay2"></div>
          <span [ngClass]="{'inStock': !item.inStock}">
            <img src="{{item?.images.large[0].url}}"
              (error)="item?.images.large[0].url ='assets/images/stbplaceholderlg.svg'" class="card-img" alt="coffe world">
          </span>
          <div class="container">
            <div style="position: absolute; top: 20px;">
            </div>
            <div class="slide-img text-right">
              <img *ngIf="!(isPanelOpened || isPanelOpened1 || isPanelOpened2)" src="assets/icon/expand.png"
                class="mr-20" alt="expand-icon" (click)="expandImage(item?.images.large[0].url)">
              <span *ngIf="verifyLogin && !isPhone">
                <img src="assets/icon/dil.svg" class="dil" alt="fav-icon" *ngIf="!item['isFavourite']"
                  (click)="addToFav(item)">
                <img src="assets/icon/heart.svg" alt="heart fill" class="icon"
                  *ngIf="item['isFavourite'] && item['isFavourite']" (click)="addToFav(item)">
              </span>
            </div>
          </div>
          <div class="card-img-overlay container"
            [ngClass]="{'move-to-top': isPanelOpened || isPanelOpened1 || isPanelOpened2 , 'top-no-barista': !baristaInfo}">
            <div class="headings">
              <div *ngIf="!(isPanelOpened || isPanelOpened1 || isPanelOpened2)">
                <div class="veg" *ngFor="let param of item.parameters">
                  <span class="veg-text-style2" *ngIf="param.name === 'VEG' && param.value === 'No'">
                    <img src="assets/icon/nonveg.svg" alt="non-veg">
                    NON-VEGETARIAN <span *ngIf="item.dietaryInformation">-</span> {{item.dietaryInformation |
                    uppercase}}
                  </span>
                  <span class="veg-text-style2" *ngIf="param.name === 'VEG' && param.value === 'Yes'">
                    <img src="assets/icon/veg.svg" alt="veg">
                    VEGETARIAN <span *ngIf="item.dietaryInformation">-</span> {{item.dietaryInformation | uppercase}}
                  </span>
                </div>
              </div>
              <div class="d-flex align-items-baseline animate__animated animate__fadeIn">
                <h5 class="card-title" style="margin-bottom: 0px;" (click)="closeAllPanels()">
                  {{item.name}}
                </h5>
                <span *ngIf="isPanelOpened || isPanelOpened1 || isPanelOpened2" class="ps-3 set-default-text"
                  (click)="setDefault()"><u>Set to default </u></span>
              </div>
              <div *ngIf="(isPanelOpened || isPanelOpened1 || isPanelOpened2)">
                <div class="veg" *ngFor="let param of item.parameters">
                  <span class="veg-text-style" *ngIf="param.name === 'VEG' && param.value === 'No'">
                    <img src="assets/icon/nonveg.svg" alt="non-veg">
                    NON-VEGETARIAN <span *ngIf="item.dietaryInformation">-</span> {{item.dietaryInformation}}
                  </span>
                  <span class="veg-text-style" *ngIf="param.name === 'VEG' && param.value === 'Yes'">
                    <img src="assets/icon/veg.svg" alt="veg">
                    VEGETARIAN <span *ngIf="item.dietaryInformation">-</span> {{item.dietaryInformation}}
                  </span>
                </div>
              </div>
              <p class="card-text" *ngIf="isMobile && !(isPanelOpened || isPanelOpened1 || isPanelOpened2)">
                {{(showMore) ? item.description : item.description | slice:0:70}}
                <span *ngIf="!showMore && item.description.length>70">...
                </span>
                <span *ngIf="item.description.length>70" (click)="showMore = !showMore"><u
                    style="font-family: 'SoDoSans_Regular';">
                    {{(showMore)? "Read Less" :"Read More"}} </u>
                </span>
              </p>
              <p class="card-text" *ngIf="!isMobile && !(isPanelOpened || isPanelOpened1 || isPanelOpened2)">
                {{(showMore) ? item.description : item.description | slice:0:200}}
                <span *ngIf="!showMore && item.description.length>200">...
                </span>
                <span *ngIf="item.description.length>200" (click)="showMore = !showMore"><u class="read-more-btn">
                    {{(showMore)? "Read Less" :"Read More"}} </u>
                </span>
              </p>
            </div>
            <div class="ingredients" *ngIf="!(isPanelOpened || isPanelOpened1 || isPanelOpened2)">
              <ng-container *ngIf="item.productIngredientsOptions && item.productIngredientsOptions.light">
                <div *ngFor="let ig of item.productIngredientsOptions.light">
                  <img src={{ig.iconUrl}} alt={{ig.alt}} />
                  {{ig.title | uppercase}}
                </div>
              </ng-container>
            </div>
            <ng-container *ngIf="baristaInfo">
              <div class="barista-half-width" style="background-color: #ffffff;"
                *ngIf="!(isPanelOpened || isPanelOpened1 || isPanelOpened2)">
                <div class="row align-items-center">
                  <div class="col-9">
                    <h4>{{baristaInfo?.baristaName}}, {{baristaInfo?.baristaTitle}}</h4>
                    <p>{{baristaInfo?.baristaContent}}</p>
                  </div>
                  <div class="col-3 text-right">
                    <div class="photo">
                      <img src="{{baristaInfo?.baristaImage.url}}" alt="barista" style="width: 85px;">
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </swiper>
  </div>
</div>
